import React, { useContext, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Project from './Project';

import { PortfolioContext } from '../../App';
const Projects = () => {
    const [projects, setProjects] = useState(null)

    useEffect(() => {
        fetch('https://raw.githubusercontent.com/asaduzzaman599/fakedata/main/portfolioData.json')
            .then(res => res.json())
            .then(data => {
                setProjects(data)
            })
    }, [])

    return (
        <div id="project">

            <hr className=' my-5' />
            <h2 className='text-center mb-4'>Projects</h2>
            <div className='container'>
                <Row xs={1} md={2} lg={3} className="g-4">
                    {
                        projects?.map(project => <Project project={project} key={project._id}></Project>)
                    }
                </Row>

            </div>
        </div>
    );
};

export default Projects;